export class QueueData{
    pending: string[];
    completed: string[];
}